// src/services/loyaltyService.js
import apiClient from "./api/client";
import ENDPOINTS from "./api/endpoints";

const loyaltyService = {
  /**
   * Fetch loyalty program configuration
   */
  getConfig: async () => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.LOYALTY_PROGRAM.GET_ALL
      );
      return response;
    } catch (error) {
      console.error("Failed to fetch loyalty program:", error);
      throw error;
    }
  },

  /**
   * Update loyalty program configuration
   */
  updateConfig: async (payload) => {
    try {
      const response = await apiClient.put(
        ENDPOINTS.LOYALTY_PROGRAM.UPDATE,
        payload
      );
      return response;
    } catch (error) {
      console.error("Failed to update loyalty program:", error);
      throw error;
    }
  },
};

export default loyaltyService;
